import decode from "jwt-decode";

var token;
export default class ContainerCloudAADService {
  setContainerCloudToken(myToken) {
    token = myToken;
  }
  getContainerCloudToken() {
    return token;
  }

  getContainerCloudRoles() {
    var claims;
    if (token && null !== token) {
      claims = decode(token);
    }

    if (claims && claims.hasOwnProperty("roles")) {
      return claims.roles;
    } else {
      return null;
    }
  } 

   isInRole(role) {
    if (this.getContainerCloudRoles()) {
      for (var i = 0; i < this.getContainerCloudRoles().length; i++) {
        if (this.getContainerCloudRoles()[i] === role) return true;
      }
    }
    return false;
  }
}